import { useInfiniteQuery } from "@tanstack/react-query"
import {
  notificationApiCalls,
  notificationQueryKeys,
} from "../api/notificationApi"
import { POPOVER_PAGE_SIZE } from "../constants"
import type { NotificationListFilters } from "../types"

export interface UseNotificationsOptions extends NotificationListFilters {
  /** Popover usage: pass the open state so the list only loads on demand. */
  enabled?: boolean
  pageSize?: number
}

/**
 * Infinite notification list, fetched on demand (`enabled`). The engine marks
 * `served_at` on these fetches — no client work needed. `refetchOnMount:
 * "always"` so reopening the popover shows fresh data.
 */
export const useNotifications = ({
  enabled = true,
  pageSize = POPOVER_PAGE_SIZE,
  unreadOnly,
  needsAction,
}: UseNotificationsOptions = {}) => {
  return useInfiniteQuery({
    queryKey: notificationQueryKeys.list({ unreadOnly, needsAction }, pageSize),
    queryFn: ({ pageParam }) =>
      notificationApiCalls.getNotifications(pageSize, pageParam, {
        unreadOnly,
        needsAction,
      }),
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
    initialPageParam: undefined as string | undefined,
    enabled,
    refetchOnMount: "always",
  })
}
